import React, { useState } from "react";
import "./Experience.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

function Experience() {
  const [selectedExperience, setSelectedExperience] = useState(null);

  const handleOpen = (index) => {
    setSelectedExperience(index);
  };

  const handleClose = () => {
    setSelectedExperience(null);
  };

  const experienceData = [
    {
      title: "Teaching Assistant",
      company: "Loyola Marymount University",
      year: "Sep. 2023 - Present",
      description: [
        "Delivered individualized and group support to students in Python and Computer Graphics courses, strengthening core technical competencies and academic outcomes.",
        "Evaluated and provided detailed feedback on coding assignments and graphics projects, promoting iterative learning and technical growth.",
        "Diagnosed and resolved student issues involving IDEs, rendering bugs, and algorithm implementation, improving efficiency and confidence in debugging practices.",
      ],
    },
    {
      title: "Software Engineer Intern",
      company: "Raffancy",
      year: "Sep. 2021 - May 2024",
      description: [
        "Designed and launched a comprehensive storage management system in React Native, streamlining inventory tracking and user interaction.",
        "Engineered an end-to-end inventory automation flow using Google Sheets API and custom QR code generation for real-time item retrieval.",
        "Built scalable backend logic for rapid data syncing, improving operational speed and transparency for client-side users.",
      ],
    },
    {
      title: "Programming Workshop Assistant",
      company: "TUMO Center for Creative Technologies",
      year: "May 2017 - Sep. 2020",
      description: [
        "Taught hands-on programming workshops to over 100 students, ranging from beginners to advanced learners.",
        "Developed modular Python curriculum and interactive exercises tailored to varied learning styles and age groups.",
        "Mentored students on project-based learning, emphasizing debugging skills, logical reasoning, and algorithm design.",
      ],
    },
    {
      title: "Frontend Developer",
      company: "Remote",
      year: "Aug 2019 - June 2022",
      description: [
        "Built and maintained high-performance web applications with React, TypeScript, and modern JavaScript, achieving pixel-perfect, accessible designs across devices.",
        "Collaborated with global clients to scope, design, and deploy solutions using component libraries, optimized rendering paths, and robust state management (Redux, Context API).",
        "Improved app load times by 40% through code splitting, dynamic imports, and rigorous Lighthouse testing. Ensured compliance with WCAG 2.1 for accessible UI/UX.",
      ],
    },
  ];

  return (
    <div className="InfoComponent">
      <h1 className="experience-intro">EXPERIENCE 🦾</h1>
      <div className="experience-container">
        {experienceData.map((exp, index) => (
          <div
            key={index}
            className="experience-item"
            onClick={() => handleOpen(index)}
          >
            <h2 className="experience-title">{exp.title}</h2>
            <p className="experience-company">{exp.company}</p>
            <p className="experience-year">
              <AccessTimeIcon />
              {exp.year}
            </p>
          </div>
        ))}
      </div>

      <Modal open={selectedExperience !== null} onClose={handleClose}>
        <Box className="experience-description-container">
          {selectedExperience !== null && (
            <>
              <button onClick={handleClose} className="close-icon">
                <CloseIcon />
              </button>
              <h2 className="experience-title">
                {experienceData[selectedExperience].title}
              </h2>
              <p className="experience-company">
                {experienceData[selectedExperience].company}
              </p>
              <p className="experience-year">
                <AccessTimeIcon />
                {experienceData[selectedExperience].year}
              </p>
              <ul className="experience-description-list">
                {experienceData[selectedExperience].description.map(
                  (point, i) => (
                    <li key={i}>{point}</li>
                  )
                )}
              </ul>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default Experience;
